import React from 'react'
import AddAdminUserContainer from '../../modules/GAAdminUsers/containers/AddAdminUserContainer/AddAdminUserContainer';

const AddGAAdminUser = () => {
  return (
    <AddAdminUserContainer />
  )
}

export default AddGAAdminUser;